import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { setFocus } from '../../misc/tools';
import GeneralButton from '../helpers/GeneralButton';
import { UIProperties } from '../UIProperties';
import ContnueButton from './ContinueButton';
import './DelegateUI.css'

var data: DelegateUIData = {
	score: 0,
	avatars: [
		{
			icon: './assets/images/general/icons/npc-headshots/Heather.png',
			name: 'RN Heather',
			isSelected: false,
			selectedWindow: -1
		},
		{
			icon: './assets/images/general/icons/npc-headshots/Ben.png',
			name: 'RN Ben',
			isSelected: false,
			selectedWindow: -1
		},
		{
			icon: './assets/images/general/icons/npc-headshots/Marco.png',
			name: 'RN Marco',
			isSelected: false,
			selectedWindow: -1
		},
		{
			icon: './assets/images/general/icons/npc-headshots/Jamie.png',
			name: 'LPN Jamie',
			isSelected: false,
			selectedWindow: -1
		},
		{
			icon: './assets/images/general/icons/npc-headshots/Miranda.png',
			name: 'RN Miranda',
			isSelected: false,
			selectedWindow: -1
		},
		{
			icon: './assets/images/general/icons/npc-headshots/ChargeNurse.png',
			name: 'Charge Nurse',
			isSelected: false,
			selectedWindow: -1,
			ignoreInSpecialCase: true
		}
	],
	windows: [
		{
			title: 'ENVIRONMENT OF CARE',
			items: [
				'Emergency exit signs lit and operable',
				'No equipment or supplies stored in stairwells or blocking fire doors',
				'Fire extinguishers secured, location identified, checked monthly',
				'Alarm pull stations visible and accessible',
				'Fire doors / linen chutes self close and positively latch',
				'Nothing stored within 18\' of the base of sprinkler heads',
				'No supplies stored directly on floor',
				'No obvious penetrations in walls / ceiling',
				'No items stored in egress corridors except for immediate use',
				'Medical gas shut off valves with distribution labels',
				'Oxygen cylinders in holders - not laying / standing on floor ',
				'Medical equipment with current PM tags',
				'Equipment is clean and in proper working order',
				'Chemicals appropriately stored, labeled and contained',
				'Current MSDS available for chemicals in work area',
				'Security systems (if any) operational',
				'Electrical panels locked',
				'Non-approved electrical equipment removed from area',
				'Housekeeping carts have chemicals locked when unattended',
				'No outdated supplies (blood tubes, dressing kits, tubing, etc)',
				'Alarms on clinical equipment activated and audible to staff'
			]
		},
		{
			title: 'CONFIDENTIALITY OF INFORMATION',
			items: [
				'Assignment boards (in public view) do not link name to diagnosis',
				'No patient identifiable information in normal trash',
				'Computers (public view) do not display patient identifiable info.',
				'Audio / visual privacy provided in registration areas',
				'Registration logs hidden from view or peel off label system utilized.',
				'Charts not left in public view Names hidden from view',
				'Charting areas do not have patient identifiable information in public'
			]
		},
		{
			title: 'MEDICATIONS',
			items: [
				'Medication room (storage areas) locked when unattended',
				'Medication carts locked / secured when unattended',
				'No medications left on top of carts',
				'All medications / syringes labeled',
				'Carts are dean and kept in orderly condition',
				'No outdated medications in carts, stock, or in refrigerator',
				'IV admixture area (if any) identified and kept in dean condition',
				'Open multi-dose vials dearly labeled with expiration date',
				'Narcotics / Schedule II drugs locked per federal / state regulations',
				'Narcotic log accurate, wastage countersigned',
				'No concentrated electrolytes on unit or dear warning labels attached',
				'Medication refrigerator temperature recorded daily',
				'Meds requiring refrigeration stored in refrigerator',
				'Internal / external medications stored separately',
				'Medication syringes labeled with drug, dose, and date',
				'Look alike / sound alike drugs stored separately from each other Warning labels or other identification used',
				'If more than one concentration of a medication, concentrations are stored separately from each other.',
				'Fluids in warmers appropriately labeled / dated Temperature of warmers recorded daily'
			]
		},
		{
			title: 'MANUALS & REFERENCE TOOLS',
			items: [
				'Department Policy and Procedures',
				'Safety Manual / Emergency Preparedness Plan',
				'Infection Control Manual',
				'Diet Manual',
				'Hospital Formulary',
				'Drug Reference Tools',
				'Medical Staff Privilege Lists'
			]
		},
		{
			title: 'CRASH CARTS / EMERGENCY DRUG BOXES',
			items: [
				'Cart clean and kept in orderly condition',
				'Medication drawer (box) locked with Pharmacy supplied lock',
				'Earliest expiration date of medications listed on cart (box)',
				'Supply drawers locked',
				'Defibrillator (including paddle wells) clean and in working order',
				'Ambu Bag supplies (age appropriate) intact and ready to use',
				'Oxygen canister secured - not empty.',
				'Portable suction in working order with appropriate supplies',
				'Respiratory supplies fully stocked',
				'Plugged into outlet when not in use.',
				'Checks performed per policy',
				'Current resuscitation guidelines on cart. No outdated references.'
			]
		},
		{
			title: 'INFECTION CONTROL / POINT OF CARE TESTING',
			items: [
				'Biohazard waste storage room locked',
				'Linen carts covered with solid bottom shelf',
				'Supply carts covered with solid bottom shelf',
				'No soiled linen bags or trash bags on floor',
				'Soiled linen containers covered - not overflowing',
				'No patient care supplies / equipment under sinks',
				'Hand washing promotional signage above sinks',
				'Isolation carts fully stocked with appropriate supplies',
				'Isolation signage posted in primary / secondary language',
				'Negative pressure rooms (if any) with air flow testing validated',
				'Clean and soiled storage areas maintained separately',
				'Patient food refrigerators clean, temperature maintained, food labeled with date opened',
				'Environment and equipment dean No tom mattresses or gurney cove',
				'No dust on high horizontal surfaces in sterile procedure areas',
				'Hand cleaning gel in appropriate areas',
				'Quality control logs for each point of care test current',
				'QC strips / solutions for each point of care test current and dated as appropriate'
			]
		},
		{
			title: 'PATIENT ROOMS / TREATMENT BAYS',
			isSpecialCase: true,
			items: [
				'Bed in lowest position',
				'Call bell within patient’s reach and in working order',
				'Clock in working order',
				'Phone in working order',
				'Privacy curtain intact and dean',
				'Room dean and orderly',
				'Bathroom dean and orderly',
				'Call bell in bathroom in working order',
				'Medical equipment plugged into electrical outlets',
				'Emergency outlets used for critical equipment',
				'Patient dean with hygiene needs met',
				'No tubes or drains touching the floor',
				'IVs labeled with patient\'s name, date hung, and solution',
				'IV tubing labeled with date hung',
				'Sharps container < 3/4 full Secured in room',
				'Waterless hand cleaning gel appropriately stored. Not expired',
				'No linen on floors',
				'Linen in rooms covered',
				'Trash bins not overflowing',
				'Nothing posted on patient doors or rooms that provide protected patient information (i.e. ISO sheets, charge sheets, etc)',
				'Method to unlock bathrooms known and available to staff'
			]
		}
	]
}

const DelegateUI = (props: UIProperties<DelegateUIConfig>) => {
	const [windowIndx, setWindowIndx] = useState(0);
	const [isContinueButtonDisabled, setIsContinueButtonDisabled] = useState(true);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [feedback, setFeedback] = useState(null);
	const [currentSpecialCaseIncorrectAttermpt, setCurrentSpecialCaseIncorrectAttermpt] = useState(0);
	return (
		<div className="delegate-ui-container in-game-ui-container ui-top-most-container" tabIndex={0} id='delegate-ui-first' aria-label="Delegate">
			<img src="./assets/images/general/components/nurse-station-computer/nurse-station-background.png"/>
			{!feedback ? <p id='delegate-ui-list-top' tabIndex={0} className="title-font" style={{
				color: 'rgb(222, 225, 156)',
				position: 'absolute',
				top: '50px',
				width: '100%',
				left: '50%',
				transform: 'translate(-50%,0)',
				textAlign: 'center'
			}}>Select a staff member to review and report back on the following items within their unit.</p> : (null)}
			{!feedback ? (
				<div style={{
					position: 'absolute',
					top: '154px',
					left: '100px',
					width: '230px'
				}}>
					{data.avatars.map((a: DelegateUIAvatar, avatarIndx) => {
						var isDisabled = (!data.windows[windowIndx].isSpecialCase && a.selectedWindow >= 0) || (data.windows[windowIndx].isSpecialCase && a.specialCaseSelectedWindow >= 0);
						var id = isContinueButtonDisabled && avatarIndx === data.avatars.length - 1 ? 'delegate-ui-last' : a.name + 'button';

						if(data.windows[windowIndx].isSpecialCase) {
							id = isContinueButtonDisabled && avatarIndx === data.avatars.length - 2 ? 'delegate-ui-last' : a.name + 'button';
						}
						return a.ignoreInSpecialCase && data.windows[windowIndx].isSpecialCase ? (null) : (
							<div key={Tools.generateGuid()} style={{
								height: '80px',
								width: '100%',
								position: 'relative'
							}}>
								<div style={{
									position: 'absolute',
									top: '50%',
									transform: 'translate(0px, -50%)',
									width: '90px',
									height: '75px'
								}}>
									<GeneralButton parameters= {{
										srcIdle: './assets/images/general/icons/frame_mentor.png',
										id: id,
										ariaLbl: a.name + '. ' + (isDisabled ? 'disabled' : (a.isSelected ? 'selected' : 'not selected')),
										srcHighlight: './assets/images/general/icons/frame_mentor_down.png',
										srcDisabled: './assets/images/general/icons/frame_mentor_desat.png',
										shouldLeaveOn: a.isSelected,
										top: '0',
										left: '0',
										width: '95.33px',
										highlightOnHover: true,
										isDisabled: isDisabled,
										onClicked: () => {
											if(!data.windows[windowIndx].isSpecialCase) {
												for(var aIn = 0; aIn < data.avatars.length; aIn++) {
													data.avatars[aIn].isSelected = false;
												}
											}

											data.avatars[avatarIndx].isSelected = true;

											setTimeout(() => {
												setFocus(a.name + 'button');
											}, 300);
											setForceUpdate(!forceUpdate);
											setIsContinueButtonDisabled(false);
										}
									}}/>

									<img style={{
										position: 'absolute',
										top: '10px',
										left: '20px',
										width: '54px',
										pointerEvents: 'none'
									}} src={a.ignoreInSpecialCase ? ('./assets/images/general/icons/npc-headshots/' + props.parameters.cNurseImg + '.png') : a.icon}/> 
								</div>
								<p className="regular-description-font" style={{
									position: 'absolute',
									left: '100px',
									margin: '0',
									top: '50%',
									transform: 'translate(0, -50%)'
								}}>{a.name}</p>
							</div>
						)
					})}
				</div>
			) : (null)}
			{!feedback ? <div style={{
			}}>
				<div style={{
					position: 'absolute',
					top: '50px',
					left: '350px',
					width: '851px',
					height: '600px',
				}}>
					{data.windows.map((w, index) => {
						return windowIndx === index ? (
							<div key={Tools.generateGuid()} style={{
								width: '100%',
								height: 'calc(100% - 95px)',
								position: 'absolute',
								top: '95px',
								overflow: 'auto'
							}}>
								<p tabIndex={0} className="regular-description-font" style={{
									color: 'rgb(222, 225, 156)',
									textAlign: 'center',
									margin: 0
									}}>{w.title}</p>
								<ul>
									{w.items.map((i) => {
										return (<li>
													<p tabIndex={0} className="regular-description-font" style={{
														margin: 0
													}}>{i}</p>
												</li>);
									})}
								</ul>
							</div>
							
							) : (null);
					})}
					{}
					
				</div>
			</div> : (null)}
			
			{feedback ? <div>
				<div style={{
							position: 'absolute',
							top: '60px',
							height: '500px',
							width: '90%',
							left: '50%',
							transform: 'translate(-50%, 0)'
						}}>
					<p tabIndex={0} id='delegate-feedback-top' className="title-font" style={{
						color: feedback.isCorrect ? 'rgba(50,255,49)' : 'rgba(255,128,0)',
						textAlign: 'center',
						fontSize: '50pt',
						marginTop: '50px',
						marginBottom: '40px'
					}}>{feedback.isCorrect ? 'CORRECT' : 'SORRY, TRY AGAIN'}</p>
					<p tabIndex={0} className="regular-description-font" style={{
						fontSize: '20pt'
					}}>{feedback.text}</p>
				</div>
			</div> : (null)}
				
			<ContnueButton parameters= {{
				top: '661px',
				left: '981px',
				width: '160px',
				id:isContinueButtonDisabled ? '' : 'delegate-ui-last',
				isDisabled: isContinueButtonDisabled,
				onClicked: () => {
					setFocus('delegate-ui-list-top');
					if(windowIndx + 1 >= data.windows.length) {
						var isCorrect = data.avatars.filter(a => a.isSelected).length === data.avatars.filter(a => !a.ignoreInSpecialCase).length;
						if(feedback && isCorrect) {
							for(var aIndx = 0; aIndx < data.avatars.length; aIndx++) {
								if(data.avatars[aIndx].isSelected && data.windows[windowIndx].isSpecialCase) {
									data.avatars[aIndx].specialCaseSelectedWindow = windowIndx;
								}
							}

							data.score = 0;
							switch(currentSpecialCaseIncorrectAttermpt) {
								case 0:
									data.score = 1000;
									break;
								case 1:
									data.score = 500;
									break;
								case 2:
									data.score = 250;
									break;
								default: 
									data.score = 0;
									break;
							}

							props.parameters.onContinueClicked(data);
							return;
						} else if(feedback) {
							setFeedback(null);
							return;
						}
						var feedbackText = 'Each staff member can check their own patient rooms. That way, everyone can support the JC visit and still keep patient safety and needs a priority.';

						var audio = document.getElementById(isCorrect ? 'correct-audio' : 'wrong-audio');
						
						if(!globals.isMuted) {
							(audio as any).play()
						}

						if(!isCorrect) {
							if(currentSpecialCaseIncorrectAttermpt === 0) {
								feedbackText = 'Delegating a limited number of staff members to check all patient rooms could be overwhelming. Please try again.';
							} else {
								feedbackText = 'This is still a limited number of staff members to check all of the patient rooms. The best option may be for each staff member to check their own patient rooms.';
							}
							setCurrentSpecialCaseIncorrectAttermpt(currentSpecialCaseIncorrectAttermpt+1);
						}

						setFocus('delegate-feedback-top');

						setFeedback({
							isCorrect: isCorrect,
							text: feedbackText
						})
						
						return;
					}

					for(var aIndx = 0; aIndx < data.avatars.length; aIndx++) {
						if(data.avatars[aIndx].isSelected) {
							data.avatars[aIndx].selectedWindow = windowIndx;
						}
						data.avatars[aIndx].isSelected = false;
					}

					setWindowIndx(windowIndx+1);
					setIsContinueButtonDisabled(true);
				}
			}}/>
		</div>
	);

};

export interface DelegateUIConfig {
	cNurseImg?: string;
	onContinueClicked: (data: DelegateUIData) => void;
}

export interface DelegateUIData {
	score: number;
	avatars: DelegateUIAvatar[];
	windows: DelegateUIWindow[];
}

export interface DelegateUIAvatar {
	icon: string;
	name: string;
	isSelected: boolean;
	ignoreInSpecialCase?: boolean;
	selectedWindow: number;
	specialCaseSelectedWindow?: number;
}

export interface DelegateUIWindow {
	title: string;
	items: string[];
	isSpecialCase?: boolean;
}

export default DelegateUI;